import React from 'react';
import { ProductGroup } from '../types';
import Modal from './Modal';

interface DeleteGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  group: ProductGroup | null;
}

const DeleteGroupModal: React.FC<DeleteGroupModalProps> = ({ isOpen, onClose, onConfirm, group }) => {
  if (!group) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Confirm Group Deletion" size="sm">
      <div className="text-slate-700">
        <p className="mb-4">
          Are you sure you want to delete group <strong className="font-semibold">{group.groupName}</strong> (ID: {group.groupId})?
        </p>
        <p className="text-sm text-red-600">This action cannot be undone and will remove the group configuration.</p>
      </div>
      <div className="mt-6 flex justify-end space-x-3">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-slate-700 bg-slate-100 hover:bg-slate-200 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={() => {
            onConfirm();
            onClose();
          }}
          className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 border border-transparent rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
        >
          Delete Group
        </button>
      </div>
    </Modal>
  );
};

export default DeleteGroupModal;